import { lazy } from "react"
import type { FC, LazyExoticComponent, ReactElement } from "react"

import { ErrorBoundary } from "react-error-boundary"

import { ErrorHint, Loadable, RootLoaderFallback } from "@/3514/components"

import { ECoachCalendarQueryKey as EQueryKey } from "./coach.calendar.api.config"

const Container: LazyExoticComponent<FC> = lazy(
    (): Promise<{ default: FC }> => import("./coach.calendar.container.relink-accounts")
)

const Page: FC = (): ReactElement => (
    <ErrorBoundary fallback={<ErrorHint isVisible />} resetKeys={[EQueryKey.RelinkAccounts()]}>
        <Loadable component={Container} loadingFallback={<RootLoaderFallback top="10%" />} />
    </ErrorBoundary>
)

Page.displayName = "CoachRelinkAccountsPage"

export { Page as CoachRelinkAccountsPage }
